import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';
import { ProjectDetailPage } from '@/pages/projects/ui/ProjectDetailPage';
import { routeValidateQuerySearch } from '@/shared/lib/route';

const querySchema = z.object({
  /** AIチャットのスレッドID */
  threadId: z.string().optional(),
});

export const Route = createFileRoute('/_protected/projects/$projectId/')({
  component: ProjectDetailPage,
  validateSearch: (record) =>
    routeValidateQuerySearch({
      record,
      usePaginationSchema: false,
      customSchema: querySchema,
      defaultValues: {},
    }),
});
